'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

const etEE = {
    el: {
        colorpicker: {
            confirm: 'Okei',
            clear: 'Selge'
        },
        datepicker: {
            now: 'Nüüd',
            today: 'Täna',
            cancel: 'Tühista',
            clear: 'Selge',
            confirm: 'Okei',
            selectDate: 'Valige kuupäev',
            selectTime: 'Valige aeg',
            startDate: 'Algus kuupäev',
            startTime: 'Algusaeg',
            endDate: 'Lõppkuupäev',
            endTime: 'Lõpuaeg',
            prevYear: 'Eelmine aasta',
            nextYear: 'Järgmine aasta',
            prevMonth: 'Eelmine kuu',
            nextMonth: 'Järgmine kuu',
            year: 'aasta',
            month1: 'jaanuar',
            month2: 'veebruar',
            month3: 'märts',
            month4: 'aprill',
            month5: 'mai',
            month6: 'juuni',
            month7: 'juuli',
            month8: 'august',
            month9: 'september',
            month10: 'oktoober',
            month11: 'november',
            month12: 'detsember',
            week: 'nädal',
            weeks: {
                sun: 'püh',
                mon: 'esm',
                tue: 'tei',
                wed: 'kol',
                thu: 'nel',
                fri: 'ree',
                sat: 'lau'
            },
            months: {
                jan: 'jaa',
                feb: 'vee',
                mar: 'mär',
                apr: 'apr',
                may: 'mai',
                jun: 'juu',
                jul: 'juu',
                aug: 'aug',
                sep: 'sep',
                oct: 'okt',
                nov: 'nov',
                dec: 'det'
            }
        },
        select: {
            loading: 'Laadimine',
            noMatch: 'Vastavaid andmeid pole',
            noData: 'Andmed puuduvad',
            placeholder: 'Valige'
        },
        cascader: {
            noMatch: 'Vastavaid andmeid pole',
            loading: 'Laadimine',
            placeholder: 'Valige',
            noData: 'Andmed puuduvad'
        },
        pagination: {
            goto: 'Minema',
            pagesize: '/ leht',
            total: 'Kokku {total}',
            pageClassifier: ''
        },
        messagebox: {
            title: 'Sõnum',
            confirm: 'OKei',
            cancel: 'Tühista',
            error: 'Sisestamine pole lubatud'
        },
        upload: {
            deleteTip: 'eemaldamiseks vajutage kustutamist',
            delete: 'Kustuta',
            preview: 'Eelvaade',
            continue: 'Jätka'
        },
        table: {
            emptyText: 'Andmed puuduvad',
            confirmFilter: 'Kinnitage',
            resetFilter: 'Lähtesta',
            clearFilter: 'Kõik',
            sumText: 'Summa'
        },
        tree: {
            emptyText: 'Andmed puuduvad'
        },
        transfer: {
            noMatch: 'Vastavaid andmeid pole',
            noData: 'Andmed puuduvad',
            titles: ['1. loetelu', '2. loetelu'],
            filterPlaceholder: 'Sisestage märksõna',
            noCheckedFormat: '{total} esemed',
            hasCheckedFormat: '{checked}/{total} kontrollitud'
        },
        image: {
            error: 'RIKKUS'
        },
        pageHeader: {
            title: 'tagasi'
        },
        popconfirm: {
            confirmButtonText: 'Jah',
            cancelButtonText: 'Ei'
        }
    }
};

exports["default"] = etEE;